<template>
  <div v-loading="loding">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!this.$route.query.id"
        >新增单节课</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="this.$route.query.id"
        >编辑单节课</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="form_box">
      <el-form
        label-position="top"
        label-width="80px"
        :model="searchForm"
        style="width: 360px"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="上传视频资源" prop="series">
          <el-upload
            class="upload-demo"
            drag
            :headers="headersData"
            :show-file-list="false"
            :action="uploadImgUrl"
            :before-upload="beforeVideoUpload"
            :on-success="handleAvatarSuccess"
            v-show="!videoUrl"
            :on-progress="uploadVideoProcess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将视频文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传mp4格式</div>
            <el-progress
              v-if="videoFlag == true"
              type="line"
              :percentage="videoUploadPercent"
              slot="tip"
            ></el-progress>
          </el-upload>

          <video
            :src="videoUrl"
            style="width: 360px; height: 180px"
            controls="controls"
            id="upvideo"
            v-show="videoShowFlag"
          >
            您的浏览器不支持视频播放
          </video>
          <canvas id="mycanvas" style="display: none"></canvas>
          <div style="position: relative" v-show="cavesSrc">
            <img :src="cavesSrc" alt="" />
            <div class="video_dialog" @click="openDialog">
              <img src="../img/video_play.png" alt="" />
            </div>
          </div>
          <el-upload
            class="upload-demo"
            :headers="headersData"
            :show-file-list="false"
            :action="uploadImgUrl"
            :before-upload="beforeVideoUpload"
            :on-success="handleAvatarSuccess"
            :on-progress="uploadVideoProcess"
            v-show="videoUrl"
          >
            <div class="el-upload__tip" slot="tip">
              <div class="el-upload__tip" slot="tip">只能上传mp4格式</div>
            </div>
            <el-button icon="el-icon-refresh">替换</el-button>
            <el-progress
              v-if="videoFlag == true"
              type="line"
              :percentage="videoUploadPercent"
              slot="tip"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传视频封面" prop="course_cover_url">
          <el-upload
            class="upload-demo"
            drag
            :show-file-list="false"
            :headers="headersData"
            :action="uploadImgUrl"
            :on-success="handleAvatarSuccessImg"
            :before-upload="beforeAvatarUploadImg"
            :on-remove="removeAvatarImg"
            v-show="!imageUrl"
            ref="upload"
            :on-progress="uploadImgProcess"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              推荐图片尺寸300*170px 大小＜30M 格式推荐 png、jpg
            </div>
            <el-progress
              v-if="imgFlag == true"
              slot="tip"
              type="line"
              :percentage="imgUploadPercent"
              style="margin-top: 30px"
            ></el-progress>
          </el-upload>
          <el-image
            style="width: 360px; height: 180px"
            v-show="imageUrl"
            :src="imageUrl"
            :preview-src-list="srcList"
          >
          </el-image>
          <el-upload
            class="upload-demo"
            :headers="headersData"
            :action="uploadImgUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccessImg"
            :before-upload="beforeAvatarUploadImg"
            :on-remove="removeAvatarImg"
            :on-progress="uploadImgProcess"
            v-show="imageUrl"
          >
            <div class="el-upload__tip" slot="tip">
              <div>推荐图片尺寸300*170px 大小＜30M 格式推荐 png、jpg</div>
            </div>
            <el-button icon="el-icon-refresh">替换</el-button>
            <el-progress
              v-if="imgFlag == true"
              slot="tip"
              type="line"
              :percentage="imgUploadPercent"
              style="margin-top: 30px"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="80"
            show-word-limit
            v-model="searchForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="类目选择" prop="cate">
          <el-cascader
            v-model="searchForm.cate"
            :options="cateList"
            :props="cascaderProps"
            placeholder="请选择"
            style="width: 360px"
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="推荐选择位" prop="posid">
          <el-select
           :clearable="true"
            v-model="searchForm.posid"
            placeholder="请选择"
            style="width: 360px"
          >
            <el-option
              v-for="item in posidList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="text-align: center" class="form_btns">
            <el-button @click="goBack">取消</el-button>
            <!-- this.$router.push("/manage_center") -->
            <el-button
              type="goon"
              style="margin-right: 24px"
              @click="submitForm"
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="视频预览"
      :visible.sync="dialogVisible"
      width="840px"
      @close="closeDialog"
    >
      <video
        :src="videoUrl"
        controls="controls"
        id="dialogvideo"
        style="width: 800px; height: 400px"
      >
        您的浏览器不支持视频播放
      </video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file_path: [],
      uploadImgUrl: `${process.env.VUE_APP_PROXY}file/upload`,
      imageUrl: "",
      videoUrl: "",
      srcList: [],
      searchForm: {
        course_cover_url: "",
        attribute: "1",
        title: "",
        cate: "",
        posid: "",
        series: [],
      },
      videoType: "",
      cavesSrc: "",
      menuKey: 1, // 用来强制刷新
      canvas_img: 1,
      videoFlag: false, // 进度条相关的
      imgFlag: false, // 进度条相关的
      videoUploadPercent: 0, // 进度条相关的
      imgUploadPercent: 0, // 进度条相关的
      videoShowFlag: false,
      loding: false,
      cateList: [],
      cascaderProps: {
        value: 'id',
        label: 'cate_name',
        children: 'children'
      },
      posidList: [
        {
          value: 1,
          label: "精品位",
        },
      ],
      rules: {
        series: [
          { required: true, message: "请上传视频资源", trigger: "change" },
        ],
        course_cover_url: [
          { required: true, message: "请上传视频封面", trigger: "change" },
        ],
        title: [
          { required: true, message: "请填写课程标题", trigger: "change" },
        ],
        cate: [
          { required: true, message: "请选择课程类目", trigger: "change" },
        ],
      },
      dialogVisible: false,
    };
  },
  mounted() {
    this.getCate()
    if (this.$route.query.id) {
      this.info(this.$route.query.id);
    }
  },
  methods: {
    // 获取课程分类
    async getCate() {
      const [err, res] = await this.$http.get("home/course/cate");
      if (err) {
        return;
      }
      
      // 过滤掉有links_src的子分类，只保留可以添加课程的分类
      const filteredData = (res.list || res).map(category => {
        if (category.children && category.children.length > 0) {
          // 过滤掉有links_src的子分类
          const filteredChildren = category.children.filter(child => !child.links_src);
          
          return {
            ...category,
            children: filteredChildren
          };
        }
        return category;
      });
      
      this.cateList = filteredData;
    },
    submitForm() {
      this.loding = true;
      if (this.$route.query.id) {
        this.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            const [err, res] = await this.$http.post("file/del_File", {
              file_path: this.file_path,
            });
            if (err) {
              this.loding = false;
              return false;
            } else {
              this.loding = false;
              const { searchForm } = this;
              // 提取二级分类ID（数组下标为1的值）
              const submitData = { ...searchForm };
              if (Array.isArray(submitData.cate) && submitData.cate.length > 1) {
                submitData.cate = submitData.cate[1];
              }
              const [err, res] = await this.$http.post("course/update", submitData);
              if (err) {
                this.loding = false;
                return false;
              }
              if (this.$route.query.status === "1") {
                const [err, res] = await this.$http.post("course/shelves", {
                  id: this.$route.query.id,
                  operation: "up",
                });
                if (err) {
                  return;
                }
              }
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.$router.push("/manage_center");
            }
          } else {
            this.loding = false;
            return false;
          }
        });
      } else {
        this.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            const { searchForm } = this;
            // 提取二级分类ID（数组下标为1的值）
            const submitData = { ...searchForm };
            if (Array.isArray(submitData.cate) && submitData.cate.length > 1) {
              submitData.cate = submitData.cate[1];
            }
            const [err, res] = await this.$http.post("course/add", submitData);
            if (err) {
              this.loding = false;
              return false;
            }
            this.loding = false;
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$router.push("/manage_center");
          } else {
            this.loding = false;
            return false;
          }
        });
      }
    },
    videoUpload() {},
    // 上传之前的函数
    async beforeVideoUpload(file) {
      let _this = this;
      return new Promise(async function (resolve, reject) {
        let fileName = file.name || "";
        let ext = fileName.split(".")[fileName.split(".").length - 1];
        _this.videoType = ext;
        let duration, width, height;
        if (ext !== "mp4") {
          _this.$message.error("上传视频应为 mp4 格式!");
          reject();
        }
        if (_this.searchForm.series.length && !_this.$route.query.id) {
          const [err, res] = await _this.$http.post("file/del_File", {
            file_path: [_this.searchForm.series[0].video_url],
          });
          if (err) {
            return false;
          }
        }

        if (_this.$route.query.id) {
          _this.file_path.push(_this.searchForm.series[0].video_url);
        }
        resolve();
      });
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      // 进度条恢复到初始状态
      let obj;
      if (this.$route.query.id) {
        obj = {
          blues_sort: 1,
          video_url: res.data.url,
          video_title: file.name,
          video_duration: res.data.time_log,
          video_file_name: res.data.name,
          id: this.searchForm.series[0].id,
        };
      } else {
        obj = {
          blues_sort: 1,
          video_url: res.data.url,
          video_title: file.name,
          video_duration: res.data.time_log,
          video_file_name: res.data.name,
        };
      }
      this.searchForm.series = [];
      this.searchForm.series.push(obj);
      this.videoUrl = URL.createObjectURL(file.raw);
      console.log(this.videoUrl);
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      ++this.menuKey;
      // 生成视频图片
      this.videoShowFlag = true;
      this.cavesSrc = false;
      const video = document.getElementById("upvideo"); // 获取视频对象
      video.src = URL.createObjectURL(file.raw); // url地址 url跟 视频流是一样的
      console.log(video.src);
      var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        this.cavesSrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.$nextTick(() => {
          this.videoShowFlag = false;
        });
      };
      this.$refs["ruleForm"].clearValidate(["series"]);
    },
    handleAvatarSuccessImg(res, file) {
      this.searchForm.course_cover_url = res.data.url;
      this.imageUrl = URL.createObjectURL(file.raw);
      this.srcList.push(this.imageUrl);
      this.imgFlag = false;
      this.imgUploadPercent = 0;
      ++this.imgKey;
      this.$refs["ruleForm"].clearValidate(["course_cover_url"]);
    },
    async beforeAvatarUploadImg(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 30;
      let flag = true;
      console.log(1);
      if (!isJPG) {
        console.log(1);
        flag = false;
        this.videoFlag = false;
        this.imgUploadPercent = 0;
        this.$message.error("上传头像图片只能是 JPG或者PNG 格式!");
        return Promise.reject(flag);
      }
      if (!isLt2M) {
        console.log(2);
        flag = false;
        this.videoFlag = false;
        this.imgUploadPercent = 0;
        this.$message.error("上传头像图片大小不能超过 30MB!");
        return Promise.reject(flag);
      }
      if (this.searchForm.course_cover_url && !this.$route.query.id) {
        const [err, res] = await this.$http.post("file/del_File", {
          file_path: [this.searchForm.course_cover_url],
        });

        if (err) {
          return false;
        }
        this.srcList = [];
      }
      if (this.$route.query.id) {
        this.file_path.push(this.searchForm.course_cover_url);
      }
      console.log(1);
      return isJPG && isLt2M;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    removeAvatarImg(file, fileList) {
      console.log(file, fileList);
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = parseInt(file.percentage);
    },
    uploadImgProcess(event, file, fileList) {
      this.imgFlag = true;
      this.imgUploadPercent = parseInt(file.percentage);
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      let video = document.getElementById("dialogvideo");
      video.pause();
    },
    goBack() {
      this.$router.push("/manage_center");
    },
    async info(id) {
      this.loding = true;
      const [err, res] = await this.$http.post("course/edit", {
        id,
      });
      if (err) {
        this.loding = false;
        return false;
      }
      this.loding = false;
      this.searchForm = res.course;
      this.searchForm.series = res.series;
      this.searchForm.posid = res.course.posid === 0 ? "" : res.course.posid;
      this.imageUrl = process.env.VUE_APP_URL + res.course.course_cover_url;
      this.videoUrl = process.env.VUE_APP_URL + res.series[0].video_url;
      this.videoFlag = false;
      this.videoShowFlag = true;
      this.cavesSrc = false;
      this.srcList.push(this.imageUrl);
      const video = document.getElementById("upvideo"); // 获取视频对象
      // const video = document.createElement("video") // 也可以自己创建video
      let binaryData = [];
      binaryData.push(process.env.VUE_APP_URL + res.series[0].video_url);
      window.URL.createObjectURL(
        new Blob(binaryData, { type: "application/zip" })
      );
      let canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        this.cavesSrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.$nextTick(() => {
          this.videoShowFlag = false;
        });
      };
      this.$refs["ruleForm"].clearValidate(["series"]);
      console.log(this.searchForm);
    },
  },
  computed: {
    headersData() {
      const loginToken = localStorage.getItem("token");
      if (!loginToken) {
        // 跳转登录
        this.$router.push("/");
      }
      return {
        Authenticator: loginToken,
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-textarea__inner {
  word-break: break-all;
}
/deep/.el-upload {
  display: inline;
}
/deep/.el-upload--text {
  display: flex;
  justify-content: center;
  text-align: center;
}
.video_dialog {
  position: absolute;
  height: 180px;
  width: 360px;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.6;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;
  img {
    width: 46px;
    height: 46px;
  }
}
.form_box {
  background: #fff;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  border-radius: 8px 8px 8px 8px;
}
.el-upload__text {
  color: #909399;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
  font-weight: 400;
  color: #303133;
}
/deep/.el-upload__tip {
  margin: 0;
  text-align: center;
}
.avatar {
  width: 360px;
  height: 180px;
}
.form_btns {
  margin-top: 26px;
  .el-button {
    padding: 8px 39px;
  }
  .el-button--goon,
  .el-button--goon:focus,
  .el-button--goon.is-active,
  .el-button--goon:active {
    background: #2ab18b;
    border-color: #2ab18b;
    color: #fff;
  }
  .el-button--goon:hover {
    background: #8cd8da;
    border-color: #8cd8da;
    color: #fff;
  }
}
/deep/.el-form-item__error {
  padding-top: 10px;
}
</style>